var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2695 9.76953H11.2695M16.2695 13.7695H11.2695M16.2695 5.76953H11.2695M7.76953 1.76953L7.76953 19.7695M6.56953 1.76953H14.9695C16.6497 1.76953 17.4898 1.76953 18.1315 2.09651C18.696 2.38413 19.1549 2.84307 19.4426 3.40756C19.7695 4.04929 19.7695 4.88937 19.7695 6.56953V14.9695C19.7695 16.6497 19.7695 17.4898 19.4426 18.1315C19.1549 18.696 18.696 19.1549 18.1315 19.4426C17.4898 19.7695 16.6497 19.7695 14.9695 19.7695H6.56953C4.88937 19.7695 4.04929 19.7695 3.40756 19.4426C2.84307 19.1549 2.38413 18.696 2.09651 18.1315C1.76953 17.4898 1.76953 16.6497 1.76953 14.9695V6.56953C1.76953 4.88937 1.76953 4.04929 2.09651 3.40756C2.38413 2.84307 2.84307 2.38413 3.40756 2.09651C4.04929 1.76953 4.88937 1.76953 6.56953 1.76953Z",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPages);
export default __webpack_public_path__ + "static/media/icon-pages.8a4d8c0ecd3661cae1e92dcd415c3412.svg";
export { ForwardRef as ReactComponent };